import FooterSub from './FooterSub';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withCountry from '../../../hocs/withCountry';
import { localiseUrlII } from 'src/common/utils/format-localised-url';

const enhance = compose(
  withCountry,
  withProps(props => ({
    companyLinks: props.companyLinks.map(link => ({
      ...link,
      url: link.url && localiseUrlII(props.model.countryModel, link.url)
    }))
  }))
);

export default enhance(FooterSub);
